import React from "react";
import {
  conversationStep,
  noConversation,
  settingButton,
  chatSectionStep,
  vanillaVMSteps,
  userFormatSteps,
  userFormatElseStep,
  promptsStep,
  promptElseStep,
  filesSteps,
  noFilesSteps,
  sharedFilesSteps,
  noSharedFilesSteps,
  docsSteps,
  imageSteps,
  imageElseSteps,
  exceFileSteps,
  excelElseFileSteps,
  databaseSteps,
  databaseElseSteps,
  neo4jSteps,
  neo4jelseSteps,
  collectionSteps,
  allTypeSteps,
} from "../components/JoyRideSteps";

export function generateJoyRideSteps(
  conversation,
  conversationId,
  type,
  userFormats,
  prompts,
  files,
  shared_files,
) {
  let steps = [
    {
      target: "#newconversation",
      content:
        "Click on the 'New Conversation' button to start a new chat. It will be added to your conversation list and automatically named 'New Chat' by default.",
      disableBeacon: true,
    },
  ];

  if (conversation.length > 0) {
    steps = steps.concat(conversationStep);
  } else {
    steps.push(noConversation);
  }

  steps.push(settingButton);

  if (conversationId) {
    steps = steps.concat(chatSectionStep);
  }

  if (type === "VANILLA LLM") {
    steps = steps.concat(vanillaVMSteps);
    steps = steps.concat(
      userFormats?.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts?.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[1],
      allTypeSteps[2],
      allTypeSteps[3],
      allTypeSteps[4],
      allTypeSteps[5],
      allTypeSteps[6],
      allTypeSteps[7],
    );
  } else if (type === "DOCS") {
    steps = steps.concat(docsSteps);
    steps = steps.concat(files?.length > 0 ? filesSteps : [noFilesSteps]);
    steps = steps.concat(
      shared_files?.length > 0 ? sharedFilesSteps : [noSharedFilesSteps],
    );
    steps = steps.concat(
      userFormats?.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts?.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[0],
      allTypeSteps[2],
      allTypeSteps[3],
      allTypeSteps[4],
      allTypeSteps[5],
      allTypeSteps[6],
      allTypeSteps[7],
    );
  } else if (type === "IMAGE") {
    steps = steps.concat(files?.length > 0 ? imageSteps : [imageElseSteps]);
    steps = steps.concat(
      userFormats?.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts?.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[0],
      allTypeSteps[1],
      allTypeSteps[3],
      allTypeSteps[4],
      allTypeSteps[5],
      allTypeSteps[6],
      allTypeSteps[7],
    );
  } else if (type === "Excel") {
    steps = steps.concat(
      files?.length > 0 ? exceFileSteps : [excelElseFileSteps],
    );
    steps = steps.concat(
      userFormats?.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts?.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[0],
      allTypeSteps[1],
      allTypeSteps[2],
      allTypeSteps[4],
      allTypeSteps[5],
      allTypeSteps[6],
      allTypeSteps[7],
    );
  } else if (type === "Database") {
    steps = steps.concat(
      files?.length > 0 ? databaseSteps : [databaseElseSteps],
    );
    steps = steps.concat(
      userFormats?.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts?.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[0],
      allTypeSteps[1],
      allTypeSteps[2],
      allTypeSteps[3],
      allTypeSteps[5],
      allTypeSteps[6],
      allTypeSteps[7],
    );
  } else if (type === "Neo4j") {
    steps = steps.concat(files?.length > 0 ? neo4jSteps : [neo4jelseSteps]);
    steps = steps.concat(
      userFormats?.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts?.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[0],
      allTypeSteps[1],
      allTypeSteps[2],
      allTypeSteps[3],
      allTypeSteps[4],
      allTypeSteps[6],
      allTypeSteps[7],
    );
  } else if (type === "COLLECTIONS") {
    steps = steps.concat(collectionSteps);
    steps = steps.concat(
      userFormats.length > 0 ? userFormatSteps : [userFormatElseStep],
    );
    steps = steps.concat(prompts.length > 0 ? promptsStep : [promptElseStep]);
    steps.push(
      allTypeSteps[0],
      allTypeSteps[1],
      allTypeSteps[2],
      allTypeSteps[3],
      allTypeSteps[4],
      allTypeSteps[5],
      allTypeSteps[7],
    );
  } else if (type === "") {
    steps = steps.concat(allTypeSteps);
  }

  return steps;
}
